import { ControlEnvelope } from '../envelope.js';
import { HostHello, HostHelloAck, ClientHello, ClientHelloAck, AuthError } from './auth.js';
import { SessionRequest, SessionApprovalPrompt, SessionApprovalDecision, SessionStarted, SessionStateChanged, SessionEnded, SessionMediaReady, EncodingMode, Resolution, Codec, Fps, JpegQuality, } from './session.js';
import { MouseEvent, KeyEvent } from './input.js';
import { ClipboardSync } from './clipboard.js';
import { Ping, Pong, NetworkStats } from './liveness.js';
import { CursorPosition } from './cursor.js';
import { ProbeCodec, ProbeCodecResult } from './codec-probe.js';
import { WebRtcOffer, WebRtcAnswer, WebRtcIceCandidate } from './webrtc.js';
export const MessageType = {
    AUTH_HOST_HELLO: 'auth.host.hello',
    AUTH_HOST_HELLO_ACK: 'auth.host.hello.ack',
    AUTH_CLIENT_HELLO: 'auth.client.hello',
    AUTH_CLIENT_HELLO_ACK: 'auth.client.hello.ack',
    AUTH_ERROR: 'auth.error',
    SESSION_REQUEST: 'session.request',
    SESSION_APPROVAL_PROMPT: 'session.approval.prompt',
    SESSION_APPROVAL_DECISION: 'session.approval.decision',
    SESSION_STARTED: 'session.started',
    SESSION_STATE_CHANGED: 'session.state.changed',
    SESSION_ENDED: 'session.ended',
    SESSION_MEDIA_READY: 'session.media.ready',
    INPUT_MOUSE: 'input.mouse',
    INPUT_KEY: 'input.key',
    CLIPBOARD_SYNC: 'clipboard.sync',
    CURSOR_POSITION: 'cursor.position',
    PROBE_CODEC: 'probe.codec',
    PROBE_CODEC_RESULT: 'probe.codec.result',
    WEBRTC_OFFER: 'webrtc.offer',
    WEBRTC_ANSWER: 'webrtc.answer',
    WEBRTC_ICE: 'webrtc.ice',
    PING: 'ping',
    PONG: 'pong',
    NET_STATS: 'net.stats',
};
const SCHEMAS = {
    [MessageType.AUTH_HOST_HELLO]: HostHello,
    [MessageType.AUTH_HOST_HELLO_ACK]: HostHelloAck,
    [MessageType.AUTH_CLIENT_HELLO]: ClientHello,
    [MessageType.AUTH_CLIENT_HELLO_ACK]: ClientHelloAck,
    [MessageType.AUTH_ERROR]: AuthError,
    [MessageType.SESSION_REQUEST]: SessionRequest,
    [MessageType.SESSION_APPROVAL_PROMPT]: SessionApprovalPrompt,
    [MessageType.SESSION_APPROVAL_DECISION]: SessionApprovalDecision,
    [MessageType.SESSION_STARTED]: SessionStarted,
    [MessageType.SESSION_STATE_CHANGED]: SessionStateChanged,
    [MessageType.SESSION_ENDED]: SessionEnded,
    [MessageType.SESSION_MEDIA_READY]: SessionMediaReady,
    [MessageType.INPUT_MOUSE]: MouseEvent,
    [MessageType.INPUT_KEY]: KeyEvent,
    [MessageType.CLIPBOARD_SYNC]: ClipboardSync,
    [MessageType.CURSOR_POSITION]: CursorPosition,
    [MessageType.PROBE_CODEC]: ProbeCodec,
    [MessageType.PROBE_CODEC_RESULT]: ProbeCodecResult,
    [MessageType.WEBRTC_OFFER]: WebRtcOffer,
    [MessageType.WEBRTC_ANSWER]: WebRtcAnswer,
    [MessageType.WEBRTC_ICE]: WebRtcIceCandidate,
    [MessageType.PING]: Ping,
    [MessageType.PONG]: Pong,
    [MessageType.NET_STATS]: NetworkStats,
};
export function parseControlMessage(raw) {
    const env = ControlEnvelope.safeParse(raw);
    if (!env.success)
        return { ok: false, error: `invalid envelope: ${env.error.message}` };
    const type = env.data.type;
    if (!Object.prototype.hasOwnProperty.call(SCHEMAS, type)) {
        return { ok: false, error: `unknown message type: ${type}` };
    }
    const schema = SCHEMAS[type];
    const payload = schema.safeParse(env.data.payload);
    if (!payload.success)
        return { ok: false, error: `invalid payload: ${payload.error.message}` };
    return { ok: true, type: type, envelope: env.data, payload: payload.data };
}
export { HostHello, HostHelloAck, ClientHello, ClientHelloAck, AuthError, SessionRequest, SessionApprovalPrompt, SessionApprovalDecision, SessionStarted, SessionStateChanged, SessionEnded, SessionMediaReady, EncodingMode, Resolution, Codec, Fps, JpegQuality, MouseEvent, KeyEvent, ClipboardSync, CursorPosition, ProbeCodec, ProbeCodecResult, WebRtcOffer, WebRtcAnswer, WebRtcIceCandidate, Ping, Pong, NetworkStats, };
//# sourceMappingURL=index.js.map